export default __webpack_public_path__ + "static/media/cloud-two.d0cc44c6.svg";